import { formatWorkingDaysForGrid } from "@/lib/formatWorkingDaysForGrid";
import { ProColumns } from "@ant-design/pro-components";

function humanizeFieldKey(key: string): string {
  if (key === "working_days") {
    return "Working Day";
  }
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
}

function cellRender(key: string) {
  return (text: unknown) => {
    if (key === "working_days") {
      return formatWorkingDaysForGrid(text);
    }
    if (key === "is_active") {
      return text ? "Yes" : "No";
    }
    return text != null && text !== "" ? String(text) : "-";
  };
}

export function buildColumnsFromGridRows(
  rows: Record<string, unknown>[]
): ProColumns<Record<string, unknown>>[] {
  if (!rows.length) {
    return [];
  }
  const preferred = ["start_time", "end_time", "working_days", "is_active"];
  const keys = Object.keys(rows[0]).filter(k => k !== "id");
  const ordered = [
    ...preferred.filter(k => keys.includes(k)),
    ...keys.filter(k => !preferred.includes(k)),
  ];
  return ordered.map(key => ({
    title: humanizeFieldKey(key),
    dataIndex: key,
    render: cellRender(key),
  }));
}

export function columnsMatchGridRows(
  columns: ProColumns<Record<string, unknown>>[],
  rows: Record<string, unknown>[]
): boolean {
  if (!rows.length || !columns.length) {
    return false;
  }
  const keys = new Set(Object.keys(rows[0]));
  return columns.some(col => {
    const idx = col.dataIndex;
    return typeof idx === "string" && keys.has(idx);
  });
}

export function buildColumnsFromSchemaGrid(
  columnGrid: { grid?: { field_name?: string; field_title?: string; field_type?: string }[] } | undefined
): ProColumns<Record<string, unknown>>[] {
  return (
    columnGrid?.grid?.map(field => {
      const fieldName = String(field.field_name ?? "").toLowerCase();
      return {
        title:
          fieldName === "working_days" ? "Working Day" : field.field_title,
        dataIndex: fieldName,
        render: cellRender(fieldName),
      };
    }) ?? []
  );
}
